import React, { memo, useMemo, useState } from "react";
import cx from "classnames";
export const EditorVideo = memo(function EditorVideo({ attrs, service, editable, onChangeMenuVisibility, }) {
    var _a;
    const src = useMemo(() => service.getVideoUrl(attrs), [attrs, service]);
    const [width] = useState(((_a = attrs.size) === null || _a === void 0 ? void 0 : _a.width) || 400);
    return (React.createElement("div", { className: cx("editor-video", `editor-video--${attrs.alignment}`), onMouseEnter: (e) => {
            if (!editable)
                return;
            return onChangeMenuVisibility(true, e.target);
        }, onMouseLeave: (e) => {
            if (!editable)
                return;
            return onChangeMenuVisibility(false, e.target);
        } },
        React.createElement("div", { className: "editor-video__wrap" },
            React.createElement("video", { controls: true, draggable: false, style: { width } },
                React.createElement("source", { src: src })))));
});
